import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Registro() {
    const [nombre, setNombre] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmar, setConfirmar] = useState('');
    const [mensaje, setMensaje] = useState({ texto: '', tipo: '' });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMensaje({ texto: '', tipo: '' });

        if (!nombre || !email || !password || !confirmar) {
            setMensaje({ texto: '❌ Todos los campos son obligatorios.', tipo: 'error' });
            return;
        }
        if (password !== confirmar) {
            setMensaje({ texto: '❌ Las contraseñas no coinciden.', tipo: 'error' });
            return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setMensaje({ texto: '❌ Por favor, introduce un formato de correo electrónico válido.', tipo: 'error' });
            return;
        }

        try {
            // --- MODIFICADO ---
            const response = await fetch('/api/registro', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ nombre, email, password }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.message || 'Error al registrar el usuario.');
            }

            setMensaje({ texto: `✅ ¡Registro exitoso! ${data.message}`, tipo: 'exito' });
            
            setNombre('');
            setEmail('');
            setPassword('');
            setConfirmar('');

        } catch (error) {
            setMensaje({ texto: `❌ ${error.message}`, tipo: 'error' });
        }
    };

    return (
        <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
            <div className="card shadow p-4" style={{ width: '100%', maxWidth: '500px' }}>
                <h2 className="text-center mb-4">Crear Cuenta</h2>
                
                {mensaje.texto && (
                    <div className={`alert ${mensaje.tipo === 'error' ? 'alert-danger' : 'alert-success'}`} role="alert">
                        {mensaje.texto}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label className="form-label">Nombre Completo</label>
                        <input
                            type="text"
                            value={nombre}
                            onChange={(e) => setNombre(e.target.value)}
                            className="form-control bg-light"
                            required
                            placeholder="Tu nombre y apellido"
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Correo Electrónico</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="form-control bg-light"
                            required
                            placeholder="ejemplo@correo.com"
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Contraseña</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="form-control bg-light"
                            required
                            placeholder="Una contraseña segura"
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Confirmar Contraseña</label>
                        <input
                            type="password"
                            value={confirmar}
                            onChange={(e) => setConfirmar(e.target.value)}
                            className="form-control bg-light"
                            required
                            placeholder="Repite la contraseña"
                        />
                    </div>
                    <button type="submit" className="btn w-100 text-white" style={{ backgroundColor: '#800020' }}>Crear Cuenta</button>
                </form>

                <div className="text-center mt-3">
                    <Link to="/login">¿Ya tienes cuenta? Inicia sesión</Link>
                </div>
            </div>
        </div>
    );
}

export default Registro;